import { css } from '@emotion/react';

import { theme } from '@bonusly/design-system';

export interface InputStyles {
	minHeight?: string;
	position?: string;
	display?: string;
	flexDirection?: string;
	height?: string;
	flex?: string;
}

export const useInputStyle = ({ minHeight, position, height, flex, display, flexDirection }: InputStyles = {}) => {
	return css`
		.tiptap {
			line-height: 1.8;
			${minHeight ? `min-height: ${minHeight};` : ''}
			padding: 0.5rem;
			display: ${display ?? 'flex'};
			flex-direction: ${flexDirection ?? 'column'};
			${position ? `position: ${position};` : ''}
			${flex ? `flex: ${flex};` : ''}
			height: ${height ?? '100%'};
		}

		// placeholder text
		.tiptap p.is-editor-empty:first-of-type::before {
			color: ${theme.colors.gray[400]};
			content: attr(data-placeholder);
			float: left;
			height: 0;
			pointer-events: none;
		}

		.tiptap [data-type='amount'] {
			background-color: ${theme.colors.green[25]};
			border-radius: 100px;
			color: ${theme.colors.green[700]};
			padding: 4px 6px;
		}

		.tiptap [data-type='hashtag'] {
			background-color: ${theme.colors.purple[25]};
			border-radius: 100px;
			color: ${theme.colors.purple[600]};
			padding: 4px 6px;
		}

		.tiptap [data-type='mention'] {
			color: ${theme.colors.blue[600]};
		}

		.tiptap [data-type='recipient'] {
			background-color: ${theme.colors.blueAlpha[100]};
			border-radius: 100px;
			color: ${theme.colors.blue[600]};
			padding: 4px 6px;
		}

		.ProseMirror:focus {
			outline: none;
		}
	`;
};
